
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateDocumentLinkDtoFormGroup() {
return new FormGroup({
    localDocumentId: new FormControl<number | undefined>(undefined, [Validators.required]),
    tenantId: new FormControl<number | undefined>(undefined, [Validators.required]),
    projectLinkId: new FormControl<number | undefined>(undefined),
    syncImmediately: new FormControl<boolean | undefined>(false),
})
;
}
      